
import React, { useState, useEffect } from "react";
import ApiService from '../../../../services/apiService';
import { useTranslation } from 'react-i18next';


const CashReports = () => {
    const [data, setData] = useState([]);
    const [pagination, setPagination] = useState();
    const { t } = useTranslation();
    const getFormattedDate = (date) => {
        return new Date(date).toISOString().slice(0, 16); // Returns format "YYYY-MM-DDTHH:mm"
    };

    const today = new Date();
    const tenDaysAgo = new Date();
    tenDaysAgo.setDate(today.getDate() - 10);

    const [formData, setFormData] = useState({
        fromDate: getFormattedDate(tenDaysAgo),
        toDate: getFormattedDate(today),
    });

    const reportType = [
        { label: "Item", value: "Products" },
        { label: "Category", value: "Category" },
        { label: "User", value: "Users" },
    ];
    const totalAmount = data?.reduce((sum, row) => sum + (parseFloat(row?.TotalRevenue) || 0), 0)
    const totaltax = data?.reduce((sum, row) => sum + (parseFloat(row?.TaxAmount) || 0), 0)
    const subTotal = data?.reduce((sum, row) => sum + (parseFloat(row?.TotalSubTotal) || 0), 0)

    const getReportData = async (newPageNo = pagination?.currentPage) => {
        try {
            const apiService = new ApiService
            const params = new URLSearchParams();
            params.append('Type', 0);
            params.append('UserId', "All");
            params.append('StartDate', formData?.fromDate);
            params.append('EndDate', formData?.toDate);
            params.append('PageNo', 1);
            params.append('PageSize', 10);
            const res = await apiService.getApiParamater('GET_CASHINOUT_REPORT', `?${params.toString()}`);
            // const res = await apiService.get('GET_CASHINOUT_REPORT');
            setData(res?.data?.result || []);
            setPagination(res.data.paginationData);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    const handleInputChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    }
    return (
        <div className='p-5'>
            <div className='row'>
                <div className='col-3'>
                    <label htmlFor="validationCustom01" className="form-label w-50">{t('from')} {t('date')}</label>
                    <input type='datetime-local' className="form-control" value={formData?.fromDate} onChange={handleInputChange} name='fromDate' />
                </div>
                <div className='col-3'>
                    <label htmlFor="validationCustom01" className="form-label w-50">{t('to')} {t('date')}</label>
                    <input type='datetime-local' className="form-control" value={formData?.toDate} onChange={handleInputChange} name='toDate' />
                </div>
                <div className='col-3 mt-3'>
                    <button className=' mt-3 addItem-btn' type="submit" onClick={getReportData}>{t('search')}</button>
                </div>
            </div>
            <div className="POsgridshad rounded p-4 mt-5">
                <div className="custom-table-container">
                    <table className="custom-table">
                        <thead>
                            <tr>
                                <th>{t('Pay Type')}</th>
                                <th>{t('UserName')}</th>
                                <th>{t('date')}</th>
                                <th>{t('Counter')}</th>
                                <th>{t('remarks')}</th>
                                <th>{t('Amount')}</th>
                            </tr>
                        </thead>
                        <tbody>
                            {data.map((item, index) => (
                                <tr>
                                    <td>{item?.CategoryName || "---"}</td>
                                    <td>{item?.TotalQuantity || "---"}</td>
                                    <td>{item?.TotalSubTotal?.toFixed(2) || "---"}</td>
                                    <td>{item?.TaxAmount?.toFixed(2) || "---"}</td>
                                    <td>{item?.TotalDiscount?.toFixed(2) || "---"}</td>
                                    <td>{item?.TotalRevenue?.toFixed(2) || "---"}</td>
                                </tr>
                            ))}
                        </tbody>
                        <tfoot>
                            <tr className="bg-green-100 font-bold">
                                <td colSpan={5} className="text-end">{t('subtotal')}</td>
                                <td>{subTotal?.toFixed(2) || "---"}</td>
                            </tr>
                            <tr className="bg-green-100 font-bold">
                                <td colSpan={5} className="text-end">{t('total')} {t('tax')}</td>
                                <td>{totaltax?.toFixed(2) || "---"}</td>
                            </tr>
                            <tr className="bg-green-100 font-bold">
                                <td colSpan={5} className="text-end">{t('total')}</td>
                                <td>{totalAmount?.toFixed(2) || "---"}</td>
                            </tr>
                        </tfoot>
                    </table>
                </div>
            </div>
        </div>
    );
};

export default CashReports;
